/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiTicketsAdminOrdersGetPageSizeParameter
 */
export interface ApiTicketsAdminOrdersGetPageSizeParameter {
}

/**
 * Check if a given object implements the ApiTicketsAdminOrdersGetPageSizeParameter interface.
 */
export function instanceOfApiTicketsAdminOrdersGetPageSizeParameter(value: object): value is ApiTicketsAdminOrdersGetPageSizeParameter {
    return true;
}

export function ApiTicketsAdminOrdersGetPageSizeParameterFromJSON(json: any): ApiTicketsAdminOrdersGetPageSizeParameter {
    return ApiTicketsAdminOrdersGetPageSizeParameterFromJSONTyped(json, false);
}

export function ApiTicketsAdminOrdersGetPageSizeParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTicketsAdminOrdersGetPageSizeParameter {
    return json;
}

export function ApiTicketsAdminOrdersGetPageSizeParameterToJSON(json: any): ApiTicketsAdminOrdersGetPageSizeParameter {
    return ApiTicketsAdminOrdersGetPageSizeParameterToJSONTyped(json, false);
}

export function ApiTicketsAdminOrdersGetPageSizeParameterToJSONTyped(value?: ApiTicketsAdminOrdersGetPageSizeParameter | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

